<template>
    <div>
        <div v-if="step == 'start'">
            <p>{{ description }}</p>
            <ul>
                <li>
                    {{ $gettext('Step 1: Download ') }} <a class="link-button" style="cursor: pointer;" @click="downloadSample">{{ download }} </a>
                </li>
                <li>
                    {{ $gettext('Step 2: Adjust downloaded file') }}
                </li>
                <li>
                    {{ $gettext('Step 3: Upload file below') }}
                </li>
            </ul>
            <span v-if="note" class="text-muted">{{ $gettext('Note: ') }}{{ note }}</span>
            <hr>
            <div v-if="hasDropdown">
                <span>{{ $gettext('Source:') }}</span>
                <div>
                    <b-form-select v-model="selected" :options="sources" class="w-25"
                        style="background-color: white"></b-form-select>
                </div>
                <br>
            </div>
            <p>{{ $gettext('Load your adjusted CSV file here:') }}</p>
            <input type="file" :ref="'input_' + type" accept=".csv" @change="error = ''; failed = false"
                class="text-primary">
            <br>
            <br>
            <GekkoButton :text="$gettext('Continue')" @click="upload" />
        </div>
        <div v-if="step == 'visualize'">
            <p class="m-0 p-0">{{ $gettext('Do not refresh the page during this process.') }}</p>
            <p class="m-0 p-0">{{ $gettext('Review your data. Make sure the data has been assigned to the correct columns. If not, please change the csv file and re-import your data.') }}</p>
            <br>
            <p>{{ entries }}</p>
            <import-data-table :rows="rows" :type="type" :source="selected" />
            <br>
            <GekkoButton :text="$gettext('Back')" @click="initialize" variant="outline-primary" class="m-1" />
            <GekkoButton :text="$gettext('Import')" @click="importFile" class="m-1" />
        </div>
        <div v-if="step == 'importing'" class="text-center">
            <div v-if="!failed">
                <b-spinner  variant="primary" label="Spinning"></b-spinner>
            </div>
        </div>
        <div v-if="step == 'uploading'" class="text-center">
            <div v-if="!failed">
                <h2>{{ $gettext('Uploading...') }}</h2>
                <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
        </div>
        <div v-if="step == 'success'" class="text-center">
            <h2>{{ $gettext('Success!') }}</h2>
            <p>{{ $gettext('All your items have been successfully imported to Gekko.') }}</p>
            <GekkoButton :text="$gettext('Go to costs')" :href="Urls['costs_display_costs']()" class="m-2" />
            <GekkoButton :text="$gettext('Go to customers')" :href="Urls['addressbook_display']()" class="m-2" />
            <GekkoButton :text="$gettext('Upload more')" @click="initialize" class="m-2" />
        </div>
        <div v-if="failed">
            <div v-if="step == 'start'">
                <span class="text-danger">{{ error }}</span>
            </div>
            <div v-if="step == 'importing'">
                <span class="text-danger">{{ error }}</span>
                <br>
                <GekkoButton :text="$gettext('Back')" @click="initialize" variant="outline-primary" class="m-1" />
            </div>
            <div v-if="step == 'uploading'">
                <div class="mb-2">
                    <p class="m-0 p-0">{{ $gettext('We have found some errors. Check your file for errors in the specific rows. Change the csv file and re-import your data.') }}</p>
                    <br>
                    <span class="text-danger">{{ error }}</span>
                    <br>
                    <GekkoButton :text="$gettext('Back')" @click="initialize" variant="outline-primary" />
                </div>
                <table v-if="lines" class="table table-striped table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th scope="col" class="border-top-0">{{ $gettext('Line number') }}</th>
                            <th scope="col" class="border-top-0">{{ $gettext('Error') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="line in lines" :key="lines.indexOf(line)">
                            <td>{{ lines.indexOf(line) + 1 }}</td>
                            <td>
                                <p v-for="item in line" :key="line.indexOf(item)"> {{ item }}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <span v-if="lines">{{ errors }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

import { promptDownload } from "@/utils/"

import ImportDataTable from "@/components/import_data/ImportDataTable";
import ImportDataService from "@/store/services/importdata.service.js";
import GekkoButton from "@/components/GekkoButton";
export default {
    name: "ImportDataFor",
    props: {
        type: String,
        typeDesc: String,
        hasDropdown: Boolean,
        note: String,
        sources: Array,
    },
    components: { ImportDataTable, GekkoButton },
    data() {
        return {
            selected: 'gekko',
            step: 'start',
            entriesFound: 0,
            rows: [],
            data: {},
            id: null,
            error: null,
            lines: null,
            failed: false
        }
    },
    computed: {
        ...mapGetters ({ 
            currentUser: 'main/getCurrentUser',
            getCompanyId: 'main/getCompanyId'
        }),
        description: function () {
            let text = this.$gettext('Here you can mass upload  %{ typeDesc } into Gekko:')
            text = this.$gettextInterpolate(text, { typeDesc: this.typeDesc })
            return text
        },
        download: function () {
            let text = this.$gettext('%{ type } example file')
            text = this.$gettextInterpolate(text, { type: this.type })
            return text
        },
        entries: function () {
            let text = this.$gettext('Total number of %{ type }: %{ entriesFound }')
            text = this.$gettextInterpolate(text, { type: this.type, entriesFound: this.entriesFound })
            return text
        },
        errors: function () {
            let text = this.$gettext('%{ lines.length } lines have errors in them')
            text = this.$gettextInterpolate(text, { lines: this.lines })
            return text
        }
    },
    methods: {
        initialize() {
            this.step = "start";
            this.error = null;
            this.failed = false;
            this.lines = null;
        },
        downloadSample () {
            if (this.type === 'costs') {
                ImportDataService.getCostsSampleBlob().then(response => {
                    promptDownload(response)
                }).catch(error => console.error('Error downloading PDF:', error));
            }
            if (this.type === 'customers') {
                ImportDataService.getCustomersSampleBlob().then(response => {
                    promptDownload(response)
                }).catch(error => console.error('Error downloading PDF:', error));
            }
        },
        upload() {
            const file = this.$refs['input_' + this.type].files[0];
            if (file) {
                this.step = "importing";
                this.error = "";
                this.data = {};
                this.data.file = file;
                this.data.user = this.currentUser.id;
                this.data.type = "import";
                // "costs" or "customers"
                this.data.subtype = this.type;
                // "gekko" or "moneybird"
                this.data.source = this.selected;
                this.data.company_profile = this.getCompanyId;
                ImportDataService.upload(this.data).then((response) => {
                    if (response.status == 201) {
                        this.step = "visualize";
                        if(response.data.number_of_costs !== "file not read"){
                            this.entriesFound = response.data.number_of_costs;
                        }
                        if(response.data.first_rows !== "file not read"){
                            this.rows = response.data.first_rows;
                        }
                        this.id = response.data.id;
                    }
                }).catch(() => {
                    this.failed = true;
                    this.error = this.$gettext('Something went wrong, please try again.');
                })
            }
            else {
                this.failed = true;
                this.error = this.$gettext('Please select a file to import.');
            }
        },
        importFile() {
            this.step = "uploading"
            ImportDataService.importFile(this.id, { 'details_request': false }).then((response) => {
                if (response.status == 200) {
                    this.step = "success"
                }
            }).catch((response) => {
                this.failed = true;
                if (response.headers['content-type'] === "application/json") {
                    if (Object.keys(response.data.errors).length !== 0) {
                        let lines = Object.values(response.data.errors);
                        if (lines.length !== 0) {
                            this.lines = lines;
                        }
                        else {
                            if (response.status == 400) {
                            this.error = this.$gettext('File is empty, there are no rows/entries, please try again.');
                            }
                        }
                    }
                    else {
                        if (response.status == 422) {
                            this.error = this.$gettext('The CSV file must have at least 5 rows.');
                        }
                        if (response.status == 400) {
                            this.error = this.$gettext('File is empty, there are no rows/entries, please try again.');
                        }
                    }
                }
                else {
                    this.error = this.$gettext('Something went wrong, please try again later.');
                }
            })
        }
    }
}
</script>
<style scoped></style>